import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import { useTranslate } from '@/state/i18n';
import { ONBOARDING_EDIT_URL } from '@/domain/account-status/utils';

/** P05: the account waits for review. Drafts are allowed; sending them waits for the approval. */
const StatusPending = () => {
  const navigate = useNavigate();
  const t = useTranslate('domain.account-status.components.StatusPending');

  return (
    <Alert
      severity="info"
      action={
        <Button
          onClick={() => navigate(ONBOARDING_EDIT_URL)}
          variant="outlined"
          size="small"
          color="inherit"
        >
          {t('reviewData')}
        </Button>
      }
    >
      <AlertTitle>{t('title')}</AlertTitle>
      {t('description')}
    </Alert>
  );
};

export default StatusPending;
